// All this redux modal code is based on http://stackoverflow.com/a/35641680/3509004
import * as React from "react"

export interface ModalWithProps {
  visit<T>(callback: <P>(type: React.ComponentType<P>, props: P) => T): T
}

export const createModalWithProps = <P>(
  type: React.ComponentType<P>,
  props: P,
): ModalWithProps => ({
  visit<T>(callback: <P2>(type: React.ComponentType<P2>, props: P2) => T): T {
    return callback(type, props)
  },
})



// WEBPACK FOOTER //
// ./src/modalTypes.ts